import { useEffect, useState } from 'react'
import useAuthStore from '../stores/Auth'

export const useGetUserInfo = () => {
  const [userInfo, setUserInfo] = useState(null)
  const state = useAuthStore((state) => state)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await state.getUser()
        setUserInfo(result)
      } catch (error) {
        console.error('Error fetching userInfo:', error)
      }
    }
    fetchData()
  }, [state])

  return userInfo
}
